import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
import AttractionsIcon from "@mui/icons-material/Attractions";
import { Box, InputAdornment } from "@mui/material";
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListSubheader,
} from "@mui/material";
import Image from "next/image";

import { Skeleton } from "@mui/material";

const HotelDestination = ({
  setCityValue,
  cityValue,
  setSearchProduct,
  searchProduct,
  selectedValue,
  setSelectedValue,
  label,
  placeholder,
  setLoading,
  loading,
  autocompleteNext,
  focusNext,
}) => {

  const flattenedOptions = cityValue.reduce((acc, curr) => {
    return [
      ...acc,
      ...curr.values.map((value) => ({
        group: curr.label,
        img: curr.img,
        ...value,
      })),
    ];
  }, []);

  return (
    <Box className={`searchMenu-loc lg:px-0 js-form-dd`}
      sx={{
        "& label.Mui-focused": {
          color: "black",
        },

        "& .MuiListSubheader-root": {
          // height: "16px",
          backgroundColor: "red",
        },
        "& .MuiInputBase-input": {
          // height: "16px",
        },
        "& .MuiAutocomplete-clearIndicator": {
          display: "none", // Hides the clear (close) button
        },

        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: "1px solid rgba(0, 0, 0, 0.5)",
        },
        "& .MuiInput-underline:after": {
          border: "1px solid rgba(0, 0, 0, 0.5)",
        },
        "& .MuiAutocomplete-listbox": {
          overflow: "hidden",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
            borderRadius: "8px",
          },
          "&:hover fieldset": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
          "&.Mui-focused fieldset": {
            border: "1px solid rgba(0, 0, 0, 0.5)",
          },
        },
        "&::-webkit-scrollbar": {
          width: "2px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "6px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
      }}>
      <Autocomplete
        value={selectedValue}
        size='small'
        onChange={(event, newValue) => {
          setSelectedValue(newValue); // Update the selected value in state
        }}
        onInputChange={(event, newInputValue) =>
          setSearchProduct(newInputValue)
        }
        openOnFocus={focusNext}
        ref={autocompleteNext}

        options={flattenedOptions}
        groupBy={(option) => option.group}
        getOptionLabel={(option) => option.name} // Display name as the label in the input
        // Custom filtering logic to match "jetski" with "Jet Ski"
        filterOptions={(options, { inputValue }) => {
          const normalizedInput = inputValue.replace(/\s+/g, "").toLowerCase(); // Remove spaces & lowercase

          return options.filter((option) => {
            const normalizedOption = option.name.replace(/\s+/g, "").toLowerCase(); // Normalize option name
            return normalizedOption.includes(normalizedInput);
          });
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <AttractionsIcon />
                </InputAdornment>
              ),
              // style: error ? { borderColor: 'red' } : {},
            }}
          // error={error}
          // helperText={helperText}
          />
        )}
        renderOption={(props, option) => (
          <ListItem {...props}>
            <div
              style={{
                minWidth: "35px",
                textAlign: "left",
              }}
            >
              <Image
                height="100"
                width="100"
                style={{
                  width: "20px",
                  height: "20px",
                }}
                alt={option.name}
                src={option.img || "/public/img/blog/2.png"}
              />
            </div>
            <ListItemText
              sx={{
                fontSize: "12px",
              }}
              primary={option?.name}
              secondary={option?.cityName?.cityName}
            />
          </ListItem>
        )}

        noOptionsText={
          loading ? <Skeleton variant="text" sx={{ fontSize: '1rem' }} /> :
            <div style={{
              padding: "16px",
              textAlign: "center",
              color: "#666",
              fontSize: "14px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px"
            }}>
              <strong style={{ fontSize: "16px", color: "#333" }}>
                No results found for {searchProduct}
              </strong>
              <p style={{ marginTop: "5px" }}>
                Try searching with a different keyword.
              </p>
            </div>
        }
      />
    </Box>
  );
};

export default HotelDestination;
